import { EKycVerificationStatus } from '@exam-center/graphql';
import {
  DoNotDisturbOnOutlinedIcon,
  CheckCircleOutlineRoundedIcon,
  CancelOutlinedIcon,
  PendingOutlinedIcon,
  PendingActionsOutlined,
  ErrorOutlineIcon,
  Tooltip,
  Text,
} from '@shared/components';

interface EKycVerificationStatusIconProps {
  eKycStatus: EKycVerificationStatus;
}

const STATUS_ICONS: Record<EKycVerificationStatus, JSX.Element> = {
  [EKycVerificationStatus.NotStarted]: (
    <DoNotDisturbOnOutlinedIcon
      sx={{
        color: (theme) => theme.palette.grey[500],
        fontSize: 20,
      }}
    />
  ),
  [EKycVerificationStatus.Approved]: (
    <CheckCircleOutlineRoundedIcon
      sx={{
        color: (theme) => theme.palette.success.main,
        fontSize: 20,
      }}
    />
  ),
  [EKycVerificationStatus.Rejected]: (
    <CancelOutlinedIcon
      sx={{
        color: (theme) => theme.palette.error.main,
        fontSize: 20,
      }}
    />
  ),
  [EKycVerificationStatus.InProgress]: (
    <PendingOutlinedIcon
      sx={{
        color: (theme) => theme.palette.primary.main,
        fontSize: 20,
      }}
    />
  ),
  [EKycVerificationStatus.PendingApproval]: (
    <PendingActionsOutlined
      sx={{
        color: (theme) => theme.palette.info.main,
        fontSize: 20,
      }}
    />
  ),
  [EKycVerificationStatus.Expired]: (
    <ErrorOutlineIcon
      sx={{
        color: (theme) => theme.palette.error.main,
        fontSize: 20,
      }}
    />
  ),
  [EKycVerificationStatus.NotRequired]: (
    <Text
      sx={(theme) => ({
        color: theme.palette.text.secondary,
        textAlign: 'left',
      })}
    >
      {'  - '}
    </Text>
  ),
  [EKycVerificationStatus.Terminated]: <></>,
};

const STATUS_TOOLTIPS: Record<EKycVerificationStatus, string> = {
  [EKycVerificationStatus.NotStarted]: 'ยังไม่ได้ยืนยันตัวตน',
  [EKycVerificationStatus.Approved]: 'ยืนยันตัวตนเรียบร้อย',
  [EKycVerificationStatus.Rejected]: 'ยืนยันตัวตนไม่สำเร็จ',
  [EKycVerificationStatus.InProgress]: 'กำลังยืนยันตัวตน',
  [EKycVerificationStatus.PendingApproval]: 'รอเจ้าหน้าที่ตรวจสอบ',
  [EKycVerificationStatus.Expired]: 'ข้อมูลหมดอายุ',
  [EKycVerificationStatus.NotRequired]: 'ไม่ต้องยืนยันตัวตน',
  [EKycVerificationStatus.Terminated]: '-',
};

export default function EKycVerificationStatusIcon(
  props: Readonly<EKycVerificationStatusIconProps>,
) {
  const { eKycStatus } = props;

  return <Tooltip title={STATUS_TOOLTIPS[eKycStatus]}>{STATUS_ICONS[eKycStatus]}</Tooltip>;
}
